/* eslint-disable react/require-default-props,react/no-unused-prop-types,prefer-destructuring */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { css } from '@emotion/core';

import { ActionButton } from '../../../../components/Buttons/ActionButton/ActionButton';
import { alertDialog } from '../../../../components/Modals/AlertDialog';
import { FontAwesome } from '../../../../components/FontAwesome';

export class ProfileHeaderFullName extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    profilePage: ImmutablePropTypes.map,
    hasEditAccess: PropTypes.bool,
    updateUserFullName: PropTypes.func,
    updateProfilePageFullNamePreview: PropTypes.func,
    updateProfilePageFullNameEditing: PropTypes.func,
    updateProfilePageFullNameSaving: PropTypes.func,
    updateProfilePageFullNameWidth: PropTypes.func,
  };

  refFullNameText = React.createRef();

  refFullNameInput = React.createRef();

  onFullNameChange = (event) => {
    const { user, updateProfilePageFullNamePreview } = this.props;
    const value = event.target.value;
    updateProfilePageFullNamePreview(user.get('profileName'), value);
  };

  onFullNameKeyPress = (event) => {
    const { user, updateProfilePageFullNameEditing } = this.props;

    switch (event.key) {
      case 'Enter':
        this.onFullNameSaveClick(
          () => {},
          () => {}
        );
        break;
      case 'Escape':
        updateProfilePageFullNameEditing(user.get('profileName'), false);
        break;
      default:
        break;
    }
  };

  onFullNameEditClick = () => {
    const {
      user,
      updateProfilePageFullNamePreview,
      updateProfilePageFullNameEditing,
      updateProfilePageFullNameWidth,
    } = this.props;

    updateProfilePageFullNamePreview(
      user.get('profileName'),
      user.get('fullName')
    );
    updateProfilePageFullNameEditing(user.get('profileName'), true);
    updateProfilePageFullNameWidth(
      user.get('profileName'),
      this.refFullNameText.current.offsetWidth
    );

    setTimeout(() => {
      updateProfilePageFullNameWidth(user.get('profileName'), 1000);

      // focus Full Name input and move the cursor to the end
      this.refFullNameInput.current.focus();
      this.refFullNameInput.current.selectionStart = 1000;
    }, 0);
  };

  onFullNameSaveClick = (accept, reject) => {
    const {
      user,
      profilePage,
      updateUserFullName,
      updateProfilePageFullNameEditing,
    } = this.props;

    updateUserFullName(user.get('id'), profilePage.get('fullName'))
      .then(() => {
        updateProfilePageFullNameEditing(user.get('profileName'), false);
        accept();
      })
      .fail((err) => {
        alertDialog({
          title: 'Error',
          message: err.message,
        });
        reject(err);
      });
  };

  render() {
    const { user, profilePage, hasEditAccess } = this.props;

    if (hasEditAccess) {
      if (profilePage.get('fullNameEditing')) {
        const nameWidth = profilePage.get('fullNameWidth');
        return (
          <div className="fullname">
            <input
              className="fullname-text fullname-input"
              css={css({
                'max-width': nameWidth ? `${nameWidth}px` : 'auto',
              })}
              value={profilePage.get('fullName')}
              onChange={this.onFullNameChange}
              onKeyDown={this.onFullNameKeyPress}
              ref={this.refFullNameInput}
            />
            <span className="info-edit fullname-edit">
              <ActionButton
                label="Save"
                icon="check"
                colour="kelp"
                onClick={this.onFullNameSaveClick}
              />
            </span>
          </div>
        );
      } else {
        return (
          <div className="fullname">
            <h1
              className={classnames('fullname-text', 'fullname-text-editable', {
                'skeleton-loading': !user.get('fullName'),
              })}
              ref={this.refFullNameText}
            >
              <button
                type="button"
                onClick={this.onFullNameEditClick}
                className="name-edit-button"
              >
                {user.get('fullName')}
              </button>
            </h1>
            {user.get('fullName') && (
              <span className="info-edit fullname-edit">
                <button
                  type="button"
                  className="info-edit-link fullname-edit-link btn-link"
                  onClick={this.onFullNameEditClick}
                >
                  <FontAwesome className="fullname-fa" name="edit" />
                  <span className="hidden-text">Update your name</span>
                </button>
              </span>
            )}
          </div>
        );
      }
    } else {
      return (
        <div className="fullname">
          <h1
            className={classnames('fullname-text', {
              'skeleton-loading': !user.get('fullName'),
            })}
          >
            {user.get('fullName')}
          </h1>
        </div>
      );
    }
  }
}
